// Appointment Flo - Med Spa Booking Platform
import React from "react";
import ReactDOM from "react-dom/client";
import "./styles/globals.css";
import App from "./App";

// Build stamp: rotates the bundle hash on demand (cache poisoning recovery)
// and gives support a quick way to check which build a browser is running.
declare global {
  interface Window {
    __AF_BUILD__?: string;
  }
}
window.__AF_BUILD__ = "2026-07-21a";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
